import axios from 'axios'

export default {
    consulta_ruc: async (document) => {
        const token = 'tjf4tioI8ISgrzRUETNIFaa5L6Ob8Ku8eMNDiPKpsHefrdaEBs';
        let url = 'https://apiperu.net/api/ruc/'

        if(document.length == 8)
            url = 'https://apiperu.net/api/dni/plus/'
        

        return await axios.get(`${url}${document}`, {
            headers: {
            authorization: `Bearer ${token}`,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': true
            },
        })
        
    }

  };
  